export function getCarpetChartData(month: number, year: number) {
  const params = new URLSearchParams()
  params.append('month', month.toString())
  params.append('year', year.toString())

  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/reportsV2/carpet-chart?${params.toString()}`,
  }
}
